export default __webpack_public_path__ + "static/media/ojk-afpi-logo.f1b60872.svg";